import styles from "./ChatUserNode.module.scss";

export interface Props {
  showMask: boolean;
  message: string;
}

export function ChatUserNode(props: Props) {
  return (
    <div className={styles.container}>
      <div className={styles.contentContainer}>
        <div className={styles.leftCorners}></div>
        <div className={styles.messageContainer}>
          <div className={styles.message}>{props.message}</div>
        </div>
        <div className={styles.rightCornersBox}>
          <div className={styles.rightTopCorners}></div>
          {props.showMask ? (
            <div className={styles.rightMessageMask}>
              <svg
                className={styles.cornerMark}
                width="24.5"
                height="20"
                viewBox="0 0 24.5 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.6589 18.6589C23.4329 18.4329 23.3199 18.3199 23.2143 18.2076C21.5436 16.4305 20.5799 14.1041 20.5048 11.6661C20.5 11.512 20.5 11.3522 20.5 11.0327V0.5H0.5V20.5H22.8963C23.0535 20.5 23.1321 20.5 23.1781 20.4957C23.979 20.4214 24.369 19.4801 23.8552 18.8612C23.8256 18.8256 23.77 18.77 23.6589 18.6589Z"
                  fill="#0A9DFF"
                  fillOpacity="0.25"
                />
              </svg>
            </div>
          ) : (
            <div className={styles.rightBottomCorners}></div>
          )}
        </div>
      </div>
    </div>
  );
}
